import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import DateTimePickerInput from '@components/common/input/DateTimePickerInput';
import { TextFieldType } from '@/type';

interface DateTimePickerFieldProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  textField: TextFieldType;
  disabled: boolean;
}

const DateTimePickerFieldController = <TFieldValues extends FieldValues = FieldValues>({
  control,
  textField,
  disabled = false,
}: DateTimePickerFieldProps<TFieldValues>) => {
  return (
    <Controller
      name={textField.name as any}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DateTimePickerInput
          field={field}
          dateField={textField}
          error={!!error}
          helperText={error ? error.message : ''}
          disabled={disabled}
        />
      )}
    />
  );
};

export default DateTimePickerFieldController;
